import React from 'react';
import { BagCost, BagOldCost, Distance, IconBack, IconBag, IconBasket, IconBattery, IconCellular, IconDirect, IconHeart, IconShare, IconWarn, IconWifi, IphoneIconsBox, PreviewBagsCount, PreviewBagsImg, PreviewBagsName, PreviewBottomBox, PreviewBox, PreviewButton, PreviewCategory, PreviewCategoryItem, PreviewDesc, PreviewDescLabel, PreviewImgBottomBox, PreviewImgBox, PreviewImgMiddleBox, PreviewImgTopBox, PreviewInfoBox, PreviewInfoRow, PreviewInfoSubBox, PreviewInfoSubRow, PreviewLogoBox, PreviewLogoImg, PreviewPointAddress, PreviewPointBox, PreviewPointName, ShareBox, TimeS, Times } from '../BagModal.styled';
import { formatDateTimeRange } from 'utils/function';






const PreviewBoxS = ({ bag, user }) => {



  return (
    <PreviewBox>
      <PreviewImgBox>
        <PreviewBagsImg src={bag.picture} />
        <PreviewImgTopBox>
          <Times>9:42</Times>
          <IphoneIconsBox>
            <IconCellular />
            <IconWifi />
            <IconBattery />
          </IphoneIconsBox>
        </PreviewImgTopBox>
        <PreviewImgMiddleBox>
          <IconBack />
          <ShareBox>
            <IconShare />
            <IconHeart />
          </ShareBox>
        </PreviewImgMiddleBox>
        <PreviewImgBottomBox>
          <PreviewBagsName>{bag.name}</PreviewBagsName>
          <PreviewBagsCount>доступно {bag.count - bag.reserved_count}</PreviewBagsCount>
        </PreviewImgBottomBox>
      </PreviewImgBox>
      <PreviewInfoBox>
        <PreviewInfoRow>
          <PreviewInfoSubRow>
            <Distance><IconDirect /> 323 м</Distance><BagOldCost>{bag.old_price} грн</BagOldCost>
          </PreviewInfoSubRow>
          <PreviewInfoSubRow>
            <TimeS><IconBasket /> {formatDateTimeRange(bag?.datetime_from, bag?.datetime_to)}</TimeS><BagCost>{bag.price} грн</BagCost>
          </PreviewInfoSubRow>
        </PreviewInfoRow>
        <PreviewInfoRow>
          <PreviewLogoBox><PreviewLogoImg src={user?.merchant?.logo} alt="Kого" /></PreviewLogoBox>
          <PreviewPointBox>
            <PreviewPointName>
              {user?.merchant?.name}
            </PreviewPointName>
            <PreviewPointAddress>
              {bag?.shop?.address}
            </PreviewPointAddress>
          </PreviewPointBox>
        </PreviewInfoRow>
        <PreviewInfoRow>
          <PreviewDescLabel>Що всередині?</PreviewDescLabel>
          <PreviewDesc>{bag.description}</PreviewDesc>
          <PreviewCategory>
            {
              bag?.categories?.map(item => (<PreviewCategoryItem key={item.id}>{item.name}</PreviewCategoryItem>))
            }
          </PreviewCategory>
        </PreviewInfoRow>
        {bag?.possibly_allergic || bag?.possibly_buffet ?
          (<PreviewInfoRow>
            {
              bag?.possibly_allergic && <PreviewInfoSubBox><IconWarn /> Містить алергени</PreviewInfoSubBox>}
            {bag?.possibly_buffet && <PreviewInfoSubBox><IconWarn /> Містить їжу зі шведського столу</PreviewInfoSubBox>
            }
          </PreviewInfoRow>) : null}
        <PreviewInfoRow>
          <PreviewInfoSubBox><IconBag /> {bag?.packing_type === "own" ? "Просимо прийти зі свою упаковкою" : "Продавець надає упаковку до замовлення"}</PreviewInfoSubBox>
        </PreviewInfoRow>
      </PreviewInfoBox>
      <PreviewBottomBox>
        <PreviewButton>Забронювати</PreviewButton>
      </PreviewBottomBox>
    </PreviewBox>

  );
};

export default PreviewBoxS;